/**
 * Parse comma-separated query parameter string into array
 * Optionally validates values against a list of allowed values
 */
export const parseArrayParam = <T extends string>(
  param: string | null,
  allowedValues?: readonly T[],
): T[] => {
  if (!param) return [];
  const values = param.split(',').filter(Boolean) as T[];

  // If allowedValues provided, filter out invalid values
  if (allowedValues) {
    return values.filter((value) => allowedValues.includes(value));
  }

  return values;
};

/**
 * Convert array to comma-separated string for URL query parameter
 * Returns null for empty arrays (removes parameter from URL)
 */
export const serializeArrayParam = (values: string[]): string | null => {
  if (values.length === 0) return null;
  return values.join(',');
};
